import { render, staticRenderFns } from "./VerifyFailDialog.vue?vue&type=template&id=5e6fc06c&scoped=true&"
import script from "./VerifyFailDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyFailDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerifyFailDialog.vue?vue&type=style&index=0&id=5e6fc06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6fc06c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
